import { Input, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

export default function LocationAutoComplete({ address, setAddress, setCoordinates }) {
  // const [address, setAddress] = useState('')
  // const [coordinates, setCoordinates] = useState({
  //   lat: null,
  //   long: null,
  // })

  const handleSelect = async (value) => {
    //console.log('VALUE : ', value)
    const results = await geocodeByAddress(value)
    //console.log('ADDRESS : ', results)
    const ll = await getLatLng(results[0])
    setAddress(value)
    setCoordinates(ll)
  }

  return (
    <PlacesAutocomplete value={address} onChange={setAddress} onSelect={handleSelect}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div style={{ marginTop: '22px' }}>
          <Typography style={{ fontWeight: 600, fontSize: '14px' }}>{'Address'}</Typography>
          <Input
            {...getInputProps({
              placeholder: 'Enter the location',
              className: 'location-search-input',
            })}
            fullWidth={true}
          />
          <div className="autocomplete-dropdown-container">
            {loading && <div>Loading...</div>}
            {suggestions.map((suggestion) => {
              const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item'
              // inline style for demonstration purpose
              const style = suggestion.active ? { backgroundColor: '#fafafa', cursor: 'pointer' } : { backgroundColor: '#ffffff', cursor: 'pointer' }
              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className,
                    style,
                  })}
                >
                  <span>{suggestion.description}</span>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  )
}
